export default "__VITE_ASSET__452f830c__"